if (typeof WiderrufBlock !== "function") {

  class WiderrufBlock extends HTMLElement {
    constructor() {
      super();
    }

    openPopup() {
      window.widerrufBlockOpened = true;
      this.classList.remove('hidden');
      document.body.classList.add("overflow-hidden");
      setTimeout(() => {
        this.background?.classList.add('visible');
      }, 100);
      setTimeout(() => {
        this.popup?.classList.add('visible');
      }, 200);
      document.querySelector('html').classList.add('lock-all');
    }

    closePopup() {
      document.body.classList.remove("overflow-hidden");
      window.widerrufBlockOpened = false;
      this.popup?.classList.remove('visible');
      this.header?.classList.remove('hidden');
      this.success?.classList.add('hidden');
      this.error?.classList.add('hidden');
      for (const input of this.inputs) {
        input.value = '';
      }
      for (const select of this.selects) {
        select.value = '';
      }
      setTimeout(() => {
        this.background?.classList.remove('visible');
      }, 100);
      setTimeout(() => {
        this.classList.add('hidden');
        this.form.classList.remove('hidden');
        this.header?.classList.remove('hidden');
        this.status.innerHTML = '';
      }, 700);
      document.querySelector('html').classList.remove('lock-all');
    }

    connectedCallback() {
      const $this = this;

      this.form = this.querySelector("form");
      if (!this.form) return;
      this.formSubmitting = false;

      this.background = this.querySelector(".ds-widerruf-block__background");
      this.popup = this.querySelector(".ds-widerruf-block__popup");
      this.status = this.querySelector(".ds-widerruf-block__status");
      this.closeBtns = this.querySelectorAll('.ds-widerruf-block__popup-close');
      this.header = this.querySelector(".ds-widerruf-block__header");
      this.success = this.querySelector(".ds-widerruf-block__success");
      this.error = this.querySelector(".ds-widerruf-block__error");
      this.inputs = this.querySelectorAll('.ds-widerruf-input');
      this.selects = this.querySelectorAll('.ds-widerruf-select');

      this.background.addEventListener('click', () => {
        $this.closePopup();
      });

      for (const closeBtn of this.closeBtns) {
        closeBtn.addEventListener('click', () => {
          $this.closePopup();
        });
      }

      window.addEventListener("widerruf-block:open", () => {
        const defaultSalutation = window.cidaasVariables?.user_details?.profile?.customFields?.salutation;
        const salutationInput = this.querySelector('.ds-widerruf-select.salutation');
        if (salutationInput && defaultSalutation) {
          if (defaultSalutation == 'Herr') {
            salutationInput.value = 'MR';
          } else if (defaultSalutation == 'Frau') {
            salutationInput.value = 'MRS';
          } else if (defaultSalutation == 'Divers') {
            salutationInput.value = 'DIVERSE';
          }
        }
        $this.openPopup();
      }, false);

      this.form.addEventListener('submit', (evt) => {
        if ($this.formSubmitting) {
          evt.preventDefault();
          return;
        }
        $this.formSubmitting = true;
        evt.preventDefault();

        if ($this.form.website && $this.form.website.value) {
          $this.formSubmitting = false;
          $this.form.classList.add('hidden');
          $this.header?.classList.add('hidden');
          $this.success?.classList.remove('hidden');
          return false;
        }

        let cidaasid = "";
        if (window.cidaasVariables?.user_details?.profile?.sub) {
          cidaasid = window.cidaasVariables.user_details.profile.sub;
        }

        const data = {
          person: {
            salutation: $this.form.salutation.value ? $this.form.salutation.value : "NA",
            firstname: $this.form.first_name.value ? $this.form.first_name.value : "",
            lastname: $this.form.name.value ? $this.form.name.value : "",
            email: $this.form.email.value ? $this.form.email.value : "",
            cidassid: cidaasid
          },
          servicerequest: {
            subject: "WIDERRUF",
            message: "",
            ordernumber: $this.form.order.value ? $this.form.order.value : ""
          }
        };

        fetch(window.contactFormUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Sas-Token': window.contactFormToken
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          setTimeout(() => {
            $this.removeAttribute("aria-busy");
            $this.querySelector("button[type='submit']")?.removeAttribute("aria-busy");
            $this.formSubmitting = false;
          }, 500);
          $this.form.classList.add('hidden');
          $this.header?.classList.add('hidden');
          if (response.ok) {
            $this.success?.classList.remove('hidden');
          } else {
            $this.error?.classList.remove('hidden');
          }
          $this.status.innerHTML = '';
        })
        .catch((error) => {
          console.error('Widerruf Fehler:', error);
          setTimeout(() => {
            $this.removeAttribute("aria-busy");
            $this.querySelector("button[type='submit']")?.removeAttribute("aria-busy");
            $this.formSubmitting = false;
          }, 500);
          $this.form.classList.add('hidden');
          $this.header?.classList.add('hidden');
          $this.error?.classList.remove('hidden');
          $this.status.innerHTML = '';
        });

        return false;
      });
    }
  }

  if (typeof customElements.get("widerruf-block") === "undefined") {
    customElements.define("widerruf-block", WiderrufBlock);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href="#widerruf"]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent("widerruf-block:open"));
    });
  });
});
